import { getWarrantyAddBrandModelFields } from '../../warranty-add/form';

export const getWarrantyEditBrandModelFields = getWarrantyAddBrandModelFields;

/** setIndex 0 = แถวแรก; แถวถัดไปใช้ mobileBrandId2 + warrantyMobileId2 ฯลฯ */
export const getWarrantyEditRowFieldNames = (setIndex) => {
  if (setIndex === 0) {
    return {
      brand: 'mobileBrandId',
      model: 'mobileModelName',
      warrantyMobileId: 'warrantyMobileId1',
    };
  }
  const n = setIndex + 1;
  return {
    brand: `mobileBrandId${n}`,
    model: `mobileModelName${n}`,
    warrantyMobileId: `warrantyMobileId${n}`,
  };
};

export const FORM_USER_REGISTRATION_WARRANTY = () => {
  const span = 24;
  return [
    {
      name: 'telephone',
      label: 'เบอร์ติดต่อ',
      type: 'INPUT_PHONE',
      placeholder: '',
      rules: {
        required: true,
        pattern: /^[0-9]{10}$/,
      },
      maxLength: 10,
      disabled: true,
    },
    {
      name: 'fullName',
      label: 'ชื่อ-นามสกุล',
      type: 'INPUT',
      placeholder: '',
      rules: {
        required: true,
      },
      disabled: true,
    },
    {
      name: 'createDate',
      label: 'วันที่เริ่มรับประกัน',
      type: 'DATE_PICKER',
      placeholder: '',
      format: 'YYYY-MM-DD',
      span,
      disabled: true,
    },
    {
      name: 'expireDate',
      label: 'วันหมดอายุ',
      type: 'DATE_PICKER',
      format: 'YYYY-MM-DD',
      placeholder: '',
      span,
      disabled: true,
    },
  ];
};

const acceptWarrantyEdit = [`image/jpeg`, 'image/png', 'image/jpg', 'image/bmp'];

/** บาร์โค้ด + ข้อมูลสินค้า (ยังไม่รวมยี่ห้อ/รุ่น — ส่วนนั้น render ตาม warrantyData.mobiles.length) */
export const FORM_WARRANTY_EDIT_PRODUCT_LEADING = ({ onEnter } = {}) => {
  const span = 24;
  return [
    {
      name: 'barcodeShortcut',
      label: 'Barcode',
      type: 'INPUT_BARCODE',
      placeholder: '',
      span,
      rules: {
        required: true,
        pattern: /^[0-9]{9}$/,
      },
      maxLength: 9,
      onEnter,
    },
    {
      name: 'productName',
      label: 'ชื่อสินค้า',
      type: 'INPUT',
      placeholder: '',
      span,
      rules: {
        required: true,
      },
      style: { width: '100%', height: '100%', minHeight: '32px' },
      disabled: true,
    },
    {
      name: 'productTypeName',
      label: 'ประเภทของสินค้า',
      type: 'INPUT',
      placeholder: '',
      span,
      rules: {
        required: true,
      },
      disabled: true,
    },
  ];
};

export const FORM_WARRANTY_EDIT_PRODUCT_TRAILING = ({
  channelBuyOptions,
  accept = acceptWarrantyEdit,
} = {}) => {
  const span = 24;
  return [
    {
      name: 'channelBuyId',
      label: 'ช่องทางการซื้อขาย',
      type: 'DROPDOWN',
      placeholder: '',
      properties: {
        options: channelBuyOptions || [],
      },
      span,
      rules: {
        required: true,
      },
    },
    {
      name: 'infoPicture',
      label: 'ชนิดรูปภาพที่ต้องการ (.png, .jpg, .jpeg, .bmp)',
      type: 'TEXT',
      span,
    },
    {
      name: 'invImageUrl',
      label: 'รูปใบเสร็จ ',
      type: 'UPLOAD',
      accept: accept.join(','),
      listType: 'picture-card',
      span: 12,
      maxCount: 1,
      rules: {
        required: true,
      },
    },
    {
      name: 'packageImageUrl',
      label: 'รูปสินค้า',
      type: 'UPLOAD',
      accept: accept.join(','),
      listType: 'picture-card',
      span: 12,
      maxCount: 1,
      rules: {
        required: true,
      },
    },
  ];
};

/**
 * ฟอร์มเต็ม (สำหรับ reference) — ยี่ห้อ/รุ่น 1 ชุด
 */
export const FORM_PRODUCT_REGISTRATION_WARRANTY = ({
  mobileBrandOptions,
  channelBuyOptions,
  onEnter,
}) => {
  return [
    ...FORM_WARRANTY_EDIT_PRODUCT_LEADING({ onEnter }),
    ...getWarrantyAddBrandModelFields(0, mobileBrandOptions),
    ...FORM_WARRANTY_EDIT_PRODUCT_TRAILING({ channelBuyOptions }),
  ];
};

export const FORM_EDIT_EXPIRED = () => {
  const span = 24;
  return [
    {
      name: 'warrantyId',
      type: 'HIDDEN',
    },
    {
      name: 'expireDate',
      label: 'วันหมดอายุ',
      type: 'DATE_PICKER',
      format: 'YYYY-MM-DD',
      placeholder: '',
      span,
      rules: {
        required: true,
      },
    },
    {
      name: 'remark',
      label: 'หมายเหตุ (ระบุได้ไม่เกิน 500 ตัวอักษร)',
      type: 'INPUT_AREA',
      placeholder: '',
      rules: {
        required: true,
        maxLength: 500,
      },
      span,
    },
  ];
};
